<template>
  <div class="col-lg-10 col-md-8 col-12 main">
    <img class="banner" src="@/assets/img/home/1.jpg"/>
  </div>
</template>
<script>
export default {
  name: "home",
  data() {
    return {

    }
  },  
  

};
</script>
<style scoped>
/* 
*{border:1px solid #000;} */

.main{height:100vh;padding:30px 15px;display:flex;justify-content:center;align-items:center;user-select:none;}

.banner{width: 100%}

@media (max-width: 768px) {
.main{padding-top:0px;height:calc(100vh - 90px);}

}

</style>